/**************************************************
 * Nombre:       Nosotros_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import {NEGRITA} from "../../../Constantes";
import fondo from '../../../Recursos/fondo_nosotros.png'
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Nosotros_Home = () => {
    const navigate = useNavigate();
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            borderRadius: 10,
                            border: 4
                        }}
                    >

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 6}}
                            sx={{
                                px: 6,
                                py: !masSM ? 6 : 8,
                                color: '#fff'
                            }}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 24 : 32}}>Nosotros</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontSize: sCell ? 16 : 18}}>Quesuditas es una empresa con
                                    trayectoria, organizada en sus procesos y guiada por un fuerte sentido humano que se
                                    refleja en cada detalle.</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                                <Button
                                    onClick={() => navigate('/Nosotros')} color={'secondary'} sx={{color: theme.palette.primary.main}}>
                                    Ver Más
                                </Button>
                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 6}}
                            sx={{
                                backgroundImage: `url(${fondo})`,
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                                borderBottomRightRadius: 36,
                                borderTopRightRadius: sCell ? 0 : 36,
                                borderBottomLeftRadius: sCell ? 36 : 0,
                                height: sCell ? 250 : 400,
                                borderLeft: sCell ? 0 : 4,
                                borderColor: '#000'
                            }}
                        >


                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Nosotros_Home